import React from "react";
import { useCart } from "../context/CartContext";
import { CardGateDialog } from "./CardGateDialog";

export const CardGateMount = () => {
  const { gateOpen, setGateOpen } = useCart();
  return <CardGateDialog open={gateOpen} onClose={() => setGateOpen(false)} />;
};
